import styled from 'styled-components';
import { motion } from 'framer-motion';

import { getSpace, getColor, mq, px2rem } from '../../../../../stylesheets/tools';

const StyledTransition = styled(motion.section)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 999;
  pointer-events: auto;
  opacity: 1;
  background: ${getColor('white')};

  &.archive-transition__overlay--close {
    transition: opacity 420ms ease-in;
    opacity: 0;
    z-index: -10;
  }

  .archive-transition__background {
    position: absolute;
    height: auto;
    z-index: 1;
    grid-row: 1 / span 3;
    bottom: 0;
    width: 100%;
    z-index: -1;
  }

  .archive-transition__media {
    height: 100%;
    width: 100%;
    object-fit: cover;
    object-position: 50% 0%;
  }

  .archive-transition__close {
    position: absolute;
    top: ${getSpace('xs')};
    left: ${getSpace('m')};
    z-index: 100;
    grid-row: 1;

    ${mq('m')} {
      right: ${px2rem('60px')};
      width: ${px2rem('34px')};
      height: ${px2rem('35px')};
    }

    svg {
      width: ${getSpace('s')};
      height: ${getSpace('s')};
      margin-top: ${px2rem('4px')};
      color: ${getColor('black')};

      ${mq('m')} {
        width: ${px2rem('34px')};
        height: ${px2rem('35px')};
        margin-top: 0;
      }
    }
  }
`;

export default StyledTransition;
